import AOS from 'aos';
import * as $ from 'jquery';
import 'jquery.cookie';
import lozad from 'lozad';
import 'owl.carousel';
import 'selectric';
import './js/appointment';
import './js/booking';
import './js/cart';
import './js/common';
import './js/cookie';
import { MessageBar, PdpGallery, TreatmentCarousel, HeroCarousel } from './js/home';
import './js/homepage';
import './js/main';
import './js/plp';
import './js/search';
import './js/services';
import './js/product';
import IMask from 'imask';
import Cleave from 'cleave.js';
import { customSelect } from './js/main'

window.$ = $;
window.Inputmask = require('inputmask').default;
window.IMask = IMask;
window.Cleave = Cleave;

$(document).ready(function () {
	$('#regButton').on('click', function () {
		var date = new Date();
		var seconds = 30;
		date.setTime(date.getTime() + seconds * 1000);
		var returnUrl = $('#return_to').val();

		$.cookie('registration', returnUrl, { path: '/', expires: date });
	});

	if ($.cookie('registration') && !location.pathname.includes('register')) {
		var returnUrl = $.cookie('registration');
		$.removeCookie('registration', { path: '/' });
		window.location.href = returnUrl;
	} else {
		$('body').removeClass('noscript');
	}

	customSelect()

	let labelFlag;

	const countrySelectDropdown = () => {
		if ($(window).width() <= 1023) {
			const lastChild = $('.mobile__navigation-list li:last-child');

			if (lastChild.length) {
				lastChild.before($('.localization__wrapper'));
			} else {
				$('.mobile__navigation-list').append($('.localization__wrapper'));
			}
		}

		const defaultSelectedOption = $('#country-select option:selected').data('flag');
		labelFlag = defaultSelectedOption;

		$('#country-select').selectric({
			disableOnMobile: false,
			nativeOnMobile: false,
			onChange: (element) => {
				const selectedOption = $(element).val();
				$('#country-select').val(selectedOption);

				$('.localization-form').submit();
			},

			onInit:(self) => {
				const ogOptions = $(self).find('option');
				const selectricOptions = $(self).parent().siblings('.selectric-items').find('ul > li');
				const label = $(self).parent().siblings('.selectric').find('span.label');

				const labelIcon = `<img src="${labelFlag}" alt="selected">`
				label.prepend(labelIcon);

				ogOptions.each((index, ogOption) => {
					const selectricItem = selectricOptions.eq(index);
					const attributes = $(ogOption).prop('attributes');
					$.each(attributes, function() {
						selectricItem.attr(this.name, this.value);
					});
				});

				selectricOptions.each(function () {
					const $this = $(this);
					const imgSrc = $this.data('flag');
					const flag = `<img src="${imgSrc}" alt="flag">`

					$this.prepend(flag);
				})
			}
		});

		if ($('.localization-dropdown').length) {
			let interval;

			interval = setInterval(() => {
				if ($('.localization-dropdown .selectric-scroll').length) {
					$('.localization-dropdown .selectric-scroll li').on('click', function () {
						const selectedOption = $(this).data('flag');
						labelFlag = selectedOption;

						const label = $('#country-select').parent().siblings('.selectric').find('span.label');
						const labelIcon = `<img src="${labelFlag}" alt="selected">`
						label.prepend(labelIcon);
					})

					clearInterval(interval)
				}
			}, 1000);
		}

		if ($('.language__local-wrapper').length && $(window).width() <= 1023) {
			const lastChild = $('.mobile__navigation-list .localization__wrapper');

			if (lastChild.length) {
				lastChild.after($('.language__local-wrapper'));
			} else {
				$('.mobile__navigation-list').append($('.language__local-wrapper'));
			}
		}
	};

	countrySelectDropdown();

	const notification = new MessageBar('#notification'),
		pdpGallery = new PdpGallery('#pdpGallery', '#pdpThumbs');

	let treatmentCarouselItem = $('.treatment-ticket-wrap'),
		treatCarousel;

	if (treatmentCarouselItem.length) {
		treatCarousel = new TreatmentCarousel('.treatment-ticket-wrap .swiper-container');
		treatCarousel.init();
	}

	new HeroCarousel().init();

	//init msg bar
	notification.init();
	notification.promotionBar('#promotionBar');

	//gallery
	new PdpGallery('#pdpGallerygift', '#pdpThumbsgift')

	var observer;
	AOS.init({
		duration: 2000,
	});

	observer = lozad('.lozad');
	observer.observe();

	$('body').on('click', '.chat-widget', function () {
		GorgiasChat.open();
	});

	$('input[type="text"], input[type="email"]').change(function () {
		this.value = $.trim(this.value);
	});

	$('.retailer-type-submit').on('click', function () {
		$('.contact__retailer-body').addClass('select-not-picked');
	})

	$('.contact-select').selectric({
		disableOnMobile: false,
		nativeOnMobile: false
	}).on('change', function () {
		const selectedValue = $(this).val();
		$('.contact__retailer-body').removeClass('select-not-picked').addClass('value-changed');

		// $('body').find('.pxFormGenerator').show();

		if (selectedValue === 'dermatology') {
			$('.contact__retailer-forms .default-form').hide();
			$('.contact__retailer-forms .app-form').show();
		} else {
			$('.contact__retailer-forms .app-form').hide();
			$('.contact__retailer-forms .default-form').show();
		}
	});
});
